import axios from 'axios';
import { Jwt } from '../Jwt';
import { LoginUser, LoginWithOtp } from '../loginUser.interface';
import { ResetPasswordUser } from '../ResetPasswordUser.interface';
import { adminAPI, webAPI } from '../../../../axiosInstance';

const login = async (user: LoginUser) => {
  return new Promise(async (resolve, reject) => {
    // fetch
    // axiosInstance
    await adminAPI
      .post('/auth/login', user)
      .then((response) => {
        // if (response.data) {
        //   localStorage.setItem('clientToken', response.data.accessToken);
        // }
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });

  });
};

const loginWithOtp = async (user: LoginWithOtp): Promise<Jwt> => {
  return new Promise(async (resolve, reject) => {
    // fetch
    // axiosInstance
    await adminAPI
      .post('/auth/login-with-otp', user)
      .then((response) => {
        if (response.data) {
          localStorage.setItem('clientToken', response.data.accessToken);
        }
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });

  });
};

const forgotPassword = async (forgotPasswordDetails: any) => {
  return new Promise((resolve, reject) => {
    adminAPI
      .post('/auth/forgot-password', forgotPasswordDetails)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const resetUserPassword = async (resetUser: any) => {
  const resetUserData = {
    password: resetUser.password,
    c_password: resetUser.confirmPassword,
    // clientToken: resetUser.clientToken,
  };
  const token = resetUser.token;
  return new Promise((resolve, reject) => {
    adminAPI
      .post(`/auth/reset-password?token=${token}`, resetUserData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const logout = async (user: any) => {
  return new Promise((resolve, reject) => {
    adminAPI
      .post(`/auth/log-out/${user.userId}`)
      .then((response) => {
        if (response.data) {
          localStorage.clear();
        }
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getProfileData = async () => {
  const response = await adminAPI.get(`/auth/profiles/admin`);
  return response.data;
};

const signUp = async (data: any) => {
  const response = await adminAPI.post('/auth/signup', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}


const authService = {
  login,
  loginWithOtp,
  logout,
  forgotPassword,
  resetUserPassword,
  getProfileData,
  signUp
};

export default authService;
